import { z } from 'zod'
import { DocumentResponseSchema } from './documents'

export const DocumentVectorSchema = z.object({
  _id: z.string().optional(),
  document: z.string(),
  individual: z.string(),
  embedding: z.array(z.number()),
  content: z.string(),
  chunkIndex: z.number(),
  createdAt: z.string(),
})

export const DocumentWithVectorsSchema = DocumentResponseSchema.extend({
  vectors: z.array(DocumentVectorSchema),
})

export type DocumentVector = z.infer<typeof DocumentVectorSchema>
export type DocumentWithVectors = z.infer<typeof DocumentWithVectorsSchema>
